import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Image, Radio, Row } from "antd";
import { SessionTypeResponse } from "../../../../organisms/MyJob/ducks/types";
import FpSessionReady from "../Components/FpSessionReady";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getFlowerDataBySessionID } from "../../../../organisms/MyJob/ducks/actions";
import { MenuSelectedIcon } from "../../../../atoms/CustomIcons";

type PropsType = {
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
  sessionData: SessionTypeResponse;
  sessionId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Step5(props: PropsType) {
  const { setCurrent, sessionId, sessionData } = props;
  const [divideData, setDivideData] = useState<null | string>(null);
  const dispatch = useAppDispatch();
  const flowerData = useAppSelector(
    (state) => state?.jobDetail?.sessionFlowerData
  );
  useEffect(() => {
    if (sessionId) {
      dispatch(getFlowerDataBySessionID(sessionId));
    }
  }, [sessionId]);

  useEffect(() => {
    if (flowerData?.petalTeams?.length === 1) {
      setDivideData("1");
    } else if (flowerData?.petalTeams?.length === 2) {
      setDivideData("2");
    } else if (flowerData?.petalTeams?.length === 3) {
      setDivideData("3");
    } else {
      setDivideData(null);
    }
  }, [flowerData]);

  return (
    <Row>
      <Col span={13}>
        <div className="session_flower finalizedFlower">
          <div
            className="flower_wrapper"
            style={{ height: "calc(100vh - 130px)" }}
          >
            {flowerData?.sessionPetals && (
              <>
                <FpSessionReady
                  data={flowerData?.sessionPetals}
                  setCurrent={setCurrent}
                  activeTab="1"
                />
                <div className="flower_position">
                  <div className="flew_wrapper">
                    <h4>{sessionData?.job?.name}</h4>
                    <p>
                      {sessionData?.c_person?.first_name ?? ""}{" "}
                      {sessionData?.c_person?.last_name ?? ""}{" "}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </Col>
      <Col span={11}>
        <Card
          className="session_fp_card fp_session_role"
          style={{ paddingTop: 137 }}
        >
          <Alert
            message="This activity is completed."
            icon={<MenuSelectedIcon />}
            type="success"
            showIcon
            style={{ marginBottom: 16, border: 0 }}
          />
          <div className="centered_div">
            <h4 style={{ marginBottom: 8 }}>Divide participants into teams</h4>
            <p style={{ marginBottom: "10px" }}>
              Each team will need to come up with a serious and funny name for
              each role.
            </p>
            <p style={{ marginBottom: "16px" }}>
              Then, the entire group debate each role name and select the one
              you agree is the best. Yes, it is like a competition, meant to be
              fun.
            </p>
            <div className="participants_card split_screen">
              <Radio.Group buttonStyle="solid" value={divideData}>
                <Radio.Button value="1" disabled>
                  <div className="participant_info" style={{ padding: 0 }}>
                    <h6>Don’t split</h6>
                  </div>
                  <div className="participant_check">
                    <Image
                      src="/images/session/checked-icon.svg"
                      preview={false}
                      width={18}
                      height={18}
                    />
                  </div>
                </Radio.Button>
                <Radio.Button value="2" disabled>
                  <div className="participant_info" style={{ padding: 0 }}>
                    <h6>2 teams</h6>
                  </div>
                  {sessionData?.participants?.length > 3 && (
                    <div className="participant_check">
                      <Image
                        src="/images/session/checked-icon.svg"
                        preview={false}
                        width={18}
                        height={18}
                      />
                    </div>
                  )}
                </Radio.Button>
                <Radio.Button value="3" disabled>
                  <div className="participant_info" style={{ padding: 0 }}>
                    <h6>3 teams</h6>
                  </div>
                  {sessionData?.participants?.length > 5 && (
                    <div className="participant_check">
                      <Image
                        src="/images/session/checked-icon.svg"
                        preview={false}
                        width={18}
                        height={18}
                      />
                    </div>
                  )}
                </Radio.Button>
              </Radio.Group>
            </div>
          </div>
          <div className="steps_footer" style={{ border: 0 }}>
            <div className="steps_btn_wrapper">
              <Button
                htmlType="button"
                className="icon_grey_btn"
                type="primary"
                size="large"
                onClick={() => setCurrent(2)}
              >
                Back
              </Button>
              <Button
                htmlType="button"
                className="icon_dark_btn"
                type="primary"
                size="large"
                onClick={() =>
                  flowerData?.petalTeams?.length > 1
                    ? setCurrent(5)
                    : setCurrent(6)
                }
              >
                Next
              </Button>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
}
